import { useState, useEffect } from "react";
import "../css/invitationpage.css";
export default function InvitationPage() {
  const prenom = localStorage.getItem("invitePrenom");
  const nom = localStorage.getItem("inviteNom");

  const [choicesList, setChoicesList] = useState([]);
  const [error, setError] = useState("");

  const [choice, setChoice] = useState("");
  const [details, setDetails] = useState("");
  const [boisson, setBoisson] = useState("");

  const [services, setServices] = useState([]); // tableau de choix multiples

  const [aperoCount, setAperoCount] = useState(0);
  const [dessertCount, setDessertCount] = useState(0);

  const [adultes, setAdultes] = useState(0);
  const [enfants, setEnfants] = useState(0);

  const MIN_SIZE = .4;   // échelle minimale
  const MAX_SIZE = 1.4; // échelle maximale

  const total = aperoCount + dessertCount;
  const scaleApero = MIN_SIZE + (aperoCount / total) * (MAX_SIZE - MIN_SIZE);
  const scaleDessert = MIN_SIZE + (dessertCount / total) * (MAX_SIZE - MIN_SIZE);

  const isLocal = window.location.hostname === "localhost";
  const API_URL = isLocal ? "http://localhost:5000/api" // backend local sans /api 
    : "/api"; // backend prod avec /api

  //  Charger la liste au démarrage
  useEffect(() => {
    const fetchChoices = async () => {
      try {
        // const response = await fetch("/choices");
        const response = await fetch(`${API_URL}/choices`);
        if (!response.ok) {
          console.error("Erreur lors du chargement des choix");
          return;
        }
        const data = await response.json();
        setChoicesList(data);
        const email = localStorage.getItem("inviteEmail");
        const existing = data.find(item => item.email === email);


        setAperoCount(data.filter(p => p.choice === "grignoter à l'apéro").length);
        setDessertCount(data.filter(p => p.choice === "déguster le dessert").length);

        if (existing) {
          setChoice(existing.choice);
          setDetails(existing.details);
          setBoisson(existing.boisson);
          setServices(existing.services || []);
          setAdultes(existing.adultes || 0);
          setEnfants(existing.enfants || 0);
        }

        setError("");
      } catch (error) {
        setError("Impossible de récupérer la liste (serveur indisponible).");
      }
    };
    fetchChoices();
    // fetch("/api/choices")
    //   .then((res) => res.json())
    //   .then((data) => setChoicesList(data));
  }, [API_URL]);




  const handleSubmit = async () => {
    if (!choice || !details || !boisson || (adultes === 0 && enfants === 0)) {
      //  || !name
      return alert("Veuillez remplir tous les champs !");
    }

    try {
      // await fetch("/add-choice", {
      const storedName = localStorage.getItem("invitePrenom") + " " + localStorage.getItem("inviteNom");
      const email = localStorage.getItem("inviteEmail");
      const response = await fetch(`${API_URL}/add-choice`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: storedName, email, choice, details, boisson, services, adultes, enfants }),
      });

      if (!response.ok) throw new Error("Serveur indisponible");

      // Recharger la liste après ajout
      const updatedList = await fetch(`${API_URL}/choices`).then((res) => res.json());
      setChoicesList(updatedList);

      alert("Votre choix a été enregistré !");
      // setDetails("");
      // setBoisson("");
      // setAdultes(0);
      // setEnfants(0);
      // setServices([]);
      // setName("");
      // setChoice("");
      setError("");
    } catch (error) {
      setError("Impossible d'enregistrer votre choix (serveur indisponible).");
    };
  };


  useEffect(() => {


    const autoRegister = async () => {
      const prenom = localStorage.getItem("invitePrenom");
      const nom = localStorage.getItem("inviteNom");
      const email = localStorage.getItem("inviteEmail");

      if (!prenom || !nom || !email) return; // Rien à faire

      const storedName = `${prenom} ${nom}`;

      try {
        await fetch(`${API_URL}/add-choice`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: storedName,
            email,
            choice: null,
            details: null,
            boisson: null,
            services: null,
            adultes: null,
            enfants: null
          }),
        });

        console.log("Auto‑enregistrement OK");
      } catch (err) {
        console.log("Auto‑enregistrement impossible");
      }
    };

    const already = localStorage.getItem("autoRegistered");
    if (!already) {
      autoRegister();
      localStorage.setItem("autoRegistered", "true");
    }
  }, [choicesList, API_URL]);

  const toggleService = (service) => {
    setServices(prev =>
      prev.includes(service)
        ? prev.filter(s => s !== service)
        : [...prev, service]
    );
  };

  // alert (aperoCount + " apéros, " + dessertCount + " desserts making a total of " + total + " contributions");

  return (
    <div className="container">
      <h1>Mariage participatif de Xavina et Samuel</h1>
      <h2>✉️ Invitation au mariage</h2>

      <h2>Bienvenue {prenom} {nom} !</h2>

      <h2>Le 16 mai 2026 à partir de 14h</h2>

      <img width='300' src="images/mariage.jpg" alt="Sam & Nina dans le jardin" className="info-photo" />

      <p>
        C'est à notre image que nous avons choisi une manière un peu particulière de célébrer avec vous notre union .<br />
        Notre histoire étant faite de partages, il nous semblait naturel que vous soyez acteuristes de <br />
        cette célébration. Chacun·e est libre de participer à sa manière, selon ses envies. <br />
        Votre présence, étant en soi, un cadeau immense.
      </p>

      <h2><strong>Lieu : </strong> Amar et Hôtes<br />
        Rue de l'Abattoir 34, 5060 Sambreville</h2>

      {/* <h2><strong>Date : </strong>Le 16 mai 2026 à 14h00</h2> */}

      <p>Nous avons imaginé un mariage à notre image : simple, chaleureux et inclusif.
        Sentez-vous libre de vous habiller comme bon vous semble.
        {/* ? La couleur du thème est le vert ? */}
      </p>

      <p>Nous serions ravis de vous compter comme participant actif à ce grand jour.
        C'est pourquoi nous avons décidé d'organiser un mariage participatif,
        où chaque ménage contribue à enrichir le menu.</p>


      <h2>🍽️ En pratique, en quoi ça consiste ?</h2>
      <p>
        Comme nous aimons souvent le faire quand nous recevons (cette fois-ci en grand),
        nous vous proposons une formule de réception à agrémenter selon vos envies.
        Nous souhaitons que cette belle journée soit construite avec votre aide et votre complicité.
      </p>

      <p>
        Par besoin d'organisation, merci de compléter le formulaire présenté ci après avant <br />
        le 15 avril 2026.
      </p>

      <h2>Votre participation</h2>
      <p>
        Vous pouvez choisir autant d'options que vous le souhaitez<br />
        Un apero/un dessert<br />
        {/* (histoire des onglets plus ou moins grand) */}
        Une boisson supplementaire ?<br />
        2 chansons play list</p>


      <p>Veuillez sélectionner une des 2 options ci-dessous :</p>
      <div className="choice-container">
        <div className={`choice-box ${choice === "grignoter à l'apéro" ? "selected" : ""}`}
          style={{ transform: `scale(${scaleDessert})` }}
          onClick={() => setChoice("grignoter à l'apéro")} >
          🥨 1 apéro
          <p>Déjà {aperoCount} choisis</p>
        </div>
        <div className={`choice-box ${choice === "déguster le dessert" ? "selected" : ""}`}
          style={{ transform: `scale(${scaleApero})` }}
          onClick={() => setChoice("déguster le dessert")} >
          🍰 1 dessert
          <p>Déjà {dessertCount} choisis</p>
        </div>
      </div>

      {!error && <>
        <div className="form">
          <textarea
            placeholder={`Que comptez-vous apporter pour ${choice || "..."}`}
            value={details}
            onChange={(e) => setDetails(e.target.value)}
          />
          <textarea
            placeholder={`Que comptez-vous apporter comme boisson`}
            value={boisson}
            onChange={(e) => setBoisson(e.target.value)}
          />

          <h2>Je propose mes services :</h2>

          <div className="choice-container">
            <div className={`choice-box ${services.includes("deco") ? "selected" : ""}`}
              onClick={() => toggleService("deco")}>
              Journée décoration en avril
            </div>

            <div className={`choice-box ${services.includes("vendredi") ? "selected" : ""}`}
              onClick={() => toggleService("vendredi")}>
              Préparation le vendredi à partir de 17h00
            </div>

            <div className={`choice-box ${services.includes("jourJ") ? "selected" : ""}`}
              onClick={() => toggleService("jourJ")}>
              Mission surprise le jour J
            </div>

            <div className={`choice-box ${services.includes("dimanche") ? "selected" : ""}`}
              onClick={() => toggleService("dimanche")}>
              Rangement le dimanche
            </div>
            {/* <div className={`choice-box ${choice === "deco" ? "selected" : ""}`}
              onClick={() => setChoice("deco")} >
              Journée décoration en avril
            </div>
            <div className={`choice-box ${choice === "vendredi" ? "selected" : ""}`}
              onClick={() => setChoice("vendredi")} >
              Préparation le vendredi à partir de 17h00
            </div>
            <div className={`choice-box ${choice === "jourJ" ? "selected" : ""}`}
              onClick={() => setChoice("jourJ")} >
              Mission surprise le jour J
            </div>
            <div className={`choice-box ${choice === "dimanche" ? "selected" : ""}`}
              onClick={() => setChoice("dimanche")} >
              Rangement le dimanche
            </div> */}
          </div>
          <p>
            Nous serons présents
            <input
              type="number"
              inputMode="numeric"
              min="0"
              max="4"
              value={adultes}
              onChange={(e) => {
                const v = e.target.value;

                // Autoriser la saisie vide (sinon impossible d'effacer)
                if (v === "") {
                  setAdultes("");
                  return;
                }

                // Autoriser la saisie tant qu'elle est numérique
                if (/^\d+$/.test(v)) {
                  setAdultes(v);
                }
              }}
              onBlur={() => {
                // Correction automatique à la sortie du champ
                let n = Number(adultes);
                if (isNaN(n)) n = 0;
                if (n < 0) n = 0;
                if (n > 4) n = 4;
                setAdultes(n);
              }}
            />
            adultes (plus de 12 ans) et
            <input
              type="number"
              inputMode="numeric"
              min="0"
              max="6"
              value={enfants}
              onChange={(e) => {
                const v = e.target.value;
                if (v === "") return setEnfants("");
                if (/^\d+$/.test(v)) setEnfants(v);
              }}
              onBlur={() => {
                let n = Number(enfants);
                if (isNaN(n)) n = 0;
                if (n < 0) n = 0;
                if (n > 6) n = 6;
                setEnfants(n);
              }}
            />            enfants (moins de 12 ans)
          </p>
          {/* <p>Nous serons présents <input type="number" min="0" max="4"
            placeholder={`nombre`}
            value={details}
            onChange={(e) => setDetails(e.target.value)}
          />
            adultes (plus de 12 ans) et <input type="number" min="0" max="6"
              placeholder={`nombre`}
              value={details}
              onChange={(e) => setDetails(e.target.value)}
            /> enfants ( moins de 12 ans)</p> */}
          <button onClick={handleSubmit}>Confirmer votre présence</button>
        </div>
      </>}

      {/* Récapitulatif de ce que vous apporterez le 16 mai : [à envoyer par mail] */}
      {/* <p className="strikethrough">
        l'apéro ou le dessert (automatique selon le choix)<br/>
        Votre viande pour le barbecue<br/>
        Des boissons supplémentaires
      </p> */}

      <p>On s'occupe du verre d'accueil, des amuses-bouches et du couscous. Pour le reste, on compte sur vous 😉</p>

      {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}

      {!error && (
        <>
          <h3>Liste des apports :</h3>
          <div className="list-container">
            {choicesList.length === 0 ? (
              <p>Aucun choix enregistré pour le moment.</p>
            ) : (
              <ul>
                {choicesList
                  .filter(item => item.details?.trim() || item.boisson?.trim())
                  .map((item, index) => (
                    <li key={index}>
                      <div className="choice-item">
                        <div className="choice-left">
                          <p className="choice-name"><strong>{item.name}</strong></p>
                        </div>
                        <p className="choice-arrow">→</p>
                        <div className="choice-right">
                          <p className="choice-line">
                            {item.choice} :{" "}
                            <strong>
                              {item.details.split("\n").map((line, i) => (
                                <span key={i}>
                                  {line}
                                  <br />
                                </span>
                              ))}
                            </strong>
                          </p>

                          <p className="choice-boisson">
                            À boire :{" "}
                            <strong>
                              {item.boisson.split("\n").map((line, i) => (
                                <span key={i}>
                                  {line}
                                  <br />
                                </span>
                              ))}
                            </strong>
                          </p>
                        </div>
                      </div>
                    </li>
                  ))}
              </ul>
            )}
          </div>
        </>
      )}

      <p>Votre présence, votre énergie et votre contribution apporteront un peu plus de magie à cette belle journée de fête.
        Nous avons hâte de vivre ce moment unique auprès de vous.</p>
    </div>
  );
}


// <li key={index}>
//   <div className="choice-item">
//     <p><strong>{item.name}</strong></p><p> → </p><div><p>{item.choice} : {item.details}</p><p>à boire : {item.boisson}</p></div>
//   </div>
// </li>
